import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AppService } from '../../app.service';
@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router, private appService: AppService) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const requiredRole = route.data['role'] || [];

    if (requiredRole.includes('ADMIN') && this.authService.isAdmin()) {
      return true;
    }

    if (requiredRole.includes('BACKOFFICE') && this.authService.isBackoffice()) {
      return true;
    }

    if (requiredRole.includes('KEY_USER') && this.appService.isKeyUser()) {
      return true;
    }

    if (requiredRole.includes('CONSULENT') && this.appService.isConsulent()) {
      return true;
    }

    this.router.navigate(['/']);
    return false;
  }
}
